import { PIC, openChoiceBox, doSubmit } from '../templates/Internals';
function getResponse(url, headers, options) {
    var _a, _b;
    let body;
    if (options === null || options === void 0 ? void 0 : options.postBody) {
        if (typeof (options === null || options === void 0 ? void 0 : options.postBody) === 'string')
            body = options.postBody;
        else if (typeof (options === null || options === void 0 ? void 0 : options.postBody) === 'object')
            body = JSON.stringify(options.postBody);
    }
    if (body && (options === null || options === void 0 ? void 0 : options.method) !== 'GET')
        return fetch(url, {
            method: (_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : 'POST',
            headers: headers,
            credentials: 'include',
            body: body
        });
    else
        return fetch(url, {
            method: (_b = options === null || options === void 0 ? void 0 : options.method) !== null && _b !== void 0 ? _b : 'POST',
            headers: headers,
            credentials: 'include',
        });
}
function doURI(front, back) {
    let arr = location.hostname.split('.');
    arr[0] = front;
    return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
}
export function exportFetchURL(options) {
    // testURI();
    let url = '';
    if (options === null || options === void 0 ? void 0 : options.url)
        url = options.url;
    else {
        // if (PIC.systemId.includes('udv') || PIC.systemId.includes('sfltest') || PIC.systemId.includes('gtstest')) url = 'https://udv.picit.dk/api' 
        // else if (PIC.systemId.match(/rnd\d+_test/)) url = 'https://rndapi.picit.dk'
        // else if (PIC.systemId.includes('_test')) url = 'https://demo.picit.dk/api'
        // else url = 'https://api.picit.dk';
        if (PIC.systemId.includes('udv') || PIC.systemId.includes('sfltest') || PIC.systemId.includes('gtstest'))
            url = doURI('udv', 'api');
        else if (PIC.systemId.match(/rnd\d+_test/))
            url = doURI('rndapi');
        else if (PIC.systemId.includes('_test'))
            url = doURI('demo', 'api');
        else
            url = doURI('api');
        if (((options === null || options === void 0 ? void 0 : options.isRestV1) || (options === null || options === void 0 ? void 0 : options.restVersion)) && options.systemId && options.path) {
            url = url + `/v1/${options.systemId}/${options.isRestV1 || options.restVersion === 'v1' ? 'v1/' : ''}${options.path}`;
        }
        else
            url += (options === null || options === void 0 ? void 0 : options.path) ? '/' + options.path : '/json';
    }
    if ((options === null || options === void 0 ? void 0 : options.path) == 'wss')
        url = url.replace('https://', '');
    return url;
}
export function exportFetchURLWithForm(options) {
    return (options === null || options === void 0 ? void 0 : options.url) ? options.url : location.href;
}
export function exportFetchHeaders(postProgram, options) {
    var _a;
    let authObj;
    if (options && options.sessionId && options.sessionId != 'undefined' && options.sessionId != undefined) {
        authObj = ['Authorization', 'Basic ' + (options === null || options === void 0 ? void 0 : options.sessionId)];
    }
    else {
        authObj = ['Authorization', 'Basic ' + btoa(':' + PIC.sessionCode)];
    }
    let returnArr = [
        authObj,
        ['Content-Type', 'application/json; charset="utf-8"'],
        ['Accept', 'application/json'],
    ];
    if ((options === null || options === void 0 ? void 0 : options.systemId) !== null && typeof (options === null || options === void 0 ? void 0 : options.restVersion) === 'undefined') {
        returnArr.push(['PICSystem', (_a = options === null || options === void 0 ? void 0 : options.systemId) !== null && _a !== void 0 ? _a : PIC.systemId]);
    }
    if (postProgram)
        returnArr.push(['PICOpCode', postProgram]);
    return returnArr;
}
function showSessionExpiredOverlay() {
    if (document.getElementById('pic-session-expired-overlay'))
        return;
    const overlay = document.createElement('div');
    overlay.id = 'pic-session-expired-overlay';
    Object.assign(overlay.style, {
        position: 'fixed', inset: '0', zIndex: '999999',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)',
    });
    const box = document.createElement('div');
    Object.assign(box.style, {
        background: '#fff', borderRadius: '12px', padding: '2rem 2.5rem',
        textAlign: 'center', boxShadow: '0 8px 32px rgba(0,0,0,.25)',
        fontFamily: 'system-ui, sans-serif', maxWidth: '380px',
    });
    const title = document.createElement('h2');
    Object.assign(title.style, { margin: '0 0 .5rem', fontSize: '1.25rem', color: '#1a1a1a' });
    title.textContent = 'Session Expired';
    const message = document.createElement('p');
    Object.assign(message.style, { margin: '0 0 1.25rem', fontSize: '.95rem', color: '#555' });
    const progressTrack = document.createElement('div');
    Object.assign(progressTrack.style, {
        width: '100%', height: '6px', borderRadius: '3px',
        background: '#e5e7eb', overflow: 'hidden',
    });
    const progressBar = document.createElement('div');
    Object.assign(progressBar.style, {
        width: '100%', height: '100%', borderRadius: '3px',
        background: '#3b82f6', transition: 'width 1s linear',
    });
    progressTrack.appendChild(progressBar);
    box.append(title, message, progressTrack);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    let remaining = 5;
    message.textContent = `You will be redirected to the main page in ${remaining} seconds…`;
    const tick = setInterval(() => {
        remaining--;
        progressBar.style.width = `${(remaining / 5) * 100}%`;
        message.textContent = `You will be redirected to the main page in ${remaining} second${remaining !== 1 ? 's' : ''}…`;
        if (remaining <= 0) {
            clearInterval(tick);
            window.location.reload();
        }
    }, 1000);
}
const handleResponse = async (response, options) => {
    var _a;
    async function res(iRes) {
        var _a, _b;
        if (options && options.formatOutput) {
            switch (options.formatOutput) {
                case 'ArrayBuffer': return iRes.arrayBuffer();
                case 'Blob': return iRes.blob();
                case 'formData': return iRes.formData();
                case 'text': {
                    if ((_b = (_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('iso-8859-1')) {
                        const data = await iRes.arrayBuffer();
                        const decoder = new TextDecoder('iso-8859-1');
                        const text = decoder.decode(data);
                        return text;
                    }
                    else
                        return iRes.text();
                }
                case 'json': return iRes.json();
                case 'raw': return iRes;
                default: return iRes;
            }
        }
        else
            return iRes.json();
    }
    const isPicApi = response.url.includes('.picit.dk');
    if (response.status === 401 && isPicApi) {
        showSessionExpiredOverlay();
        return Promise.reject('Unauthorized');
    }
    //Trigger internal error handling from APIs
    if (response.status === 409 && isPicApi) {
        const errorMessage = await response.json();
        switch (errorMessage.errorCode) {
            case 'display-message':
                openChoiceBox('pic-choicebox[choicebox-x]', {
                    choiceTitle: (_a = errorMessage.errorMessage) !== null && _a !== void 0 ? _a : 'Error',
                    choices: [
                        { choiceText: 'OK', choiceEvent: '' }
                    ]
                });
                break;
            case 'send-event':
                doSubmit(errorMessage.errorMessage ? errorMessage.errorMessage : 'refresh');
                break;
            default: {
                console.error('Unhandled error code: ' + errorMessage.errorCode);
            }
        }
        return Promise.reject('');
    }
    if (options && options.errorReturn) {
        if (response.status == 200) {
            return res(response);
        }
        else if (response.status > 200 && response.status < 300) {
            return res(response);
        }
        else if (response.status >= 300 && response.status < 400) {
            return Promise.reject(response.statusText);
        }
        else if (response.status >= 400 && response.status < 500) {
            return Promise.reject(response.statusText);
        }
        else {
            return Promise.reject(response.statusText);
        }
    }
    else {
        if (!response.ok)
            console.log('fetch has failed');
        else
            return res(response);
    }
};
export const fetchWithFormData = async (options) => {
    var _a, _b;
    let url = exportFetchURLWithForm(options);
    const headers = [
        ['Content-Type', 'application/x-www-form-urlencoded'],
    ];
    const response = await fetch(url, {
        method: (_a = options === null || options === void 0 ? void 0 : options.method) !== null && _a !== void 0 ? _a : 'POST',
        headers: headers,
        credentials: 'include',
        body: (_b = options.formData) !== null && _b !== void 0 ? _b : null
    });
    return handleResponse(response, options);
};
export const fetchApiData = async (postProgram, options) => {
    if (!PIC.systemId && PIC.getInstance.fromProgress)
        return Promise.reject('No system id found');
    if (postProgram == '/incl/loadpage') {
        if (window.modalIsLoading)
            return Promise.reject('Modal is already loading');
        window.modalIsLoading = true;
    }
    let url = exportFetchURL(options);
    const headers = exportFetchHeaders(postProgram, options);
    const response = await getResponse(url, headers, options);
    return handleResponse(response, options);
};
export const fetchRestApi = async (body, options) => {
    var _a;
    //`/api/v1/${options.picsystem}/v1/${options.path}`
    let url = exportFetchURL({ restVersion: (_a = options.restVersion) !== null && _a !== void 0 ? _a : 'base', systemId: options.picsystem, path: options.path }); //BREAKING CHANGE??
    const headers = exportFetchHeaders('', { restVersion: 'v1' });
    const request = new Request(url, {
        method: options.httpMethod,
        headers: headers,
        credentials: 'include',
        body: body
    });
    return fetch(request);
};
//# sourceMappingURL=FetchApiData.js.map